@let entityId = entityId$ | async;
@let isAdmin = isAdmin$ | async;
@let isEcommerceMode = isEcommerceMode$ | async;
@let hideControls = hideControls$ | async;

<div
    #blockRoot
    class="block"
    [id]="displayId()"
    [attr.data-raw-id]="displayId()"
    [class.active]="entityId === entity().id"
    [class.active-more-action]="isSettingsMenuOpened()"
    [webSingleHover]="{ threshold: 100 }"
    (hovered)="hovered($event)"
>
    <div
        class="info-label-container"
        [class.row-controls]="itemControls().rowControls"
        [class.basic-controls-position]="itemControls().basicControlsPosition"
        [class.small-top-indent]="itemControls().smallTopIndent"
        [class.small-bottom-indent]="itemControls().smallBottomIndent"
        [class.bottom-inner-controls-position]="itemControls().bottomInnerControlsPosition"
        [class.bottom-outer-controls-position]="itemControls().bottomOuterControlsPosition"
        [class.hidden-shared-block-info-label]="isBlockHidden()"
    >
        <div
            class="info-label shared-label"
            [tooltip]="sharedBlockTooltip"
            [placement]="'bottom'"
            [tooltipAppendToBody]="true"
        >
            <img src="./assets/img/websites/lpc-shared-block-icon-w.svg" alt="shared blocks" />
            <ng-template #sharedBlockTooltip>
                {{ hintText() | translate }}
            </ng-template>
        </div>
        @if (isPinnedTop() || isPinnedBottom()) {
            <div [tooltip]="pinnedBlockTooltip" [tooltipAppendToBody]="true" class="info-label">
                <img
                    src="./assets/img/websites/lpc-pinned-block-label-icon.svg"
                    [alt]="'control_block_pinned' | translate"
                />
                <ng-template #pinnedBlockTooltip>
                    {{ "control_block_pinned" | translate }}
                </ng-template>
            </div>
        }
        @if (hidden().desktop || hidden().tablet || hidden().mobile) {
            <div class="info-label" [tooltip]="hiddenBlockTooltip" [tooltipAppendToBody]="true">
                <img [src]="hiddenIconPath()" [alt]="hiddenIconTooltip() | translate" />
                <ng-template #hiddenBlockTooltip>
                    {{ hiddenIconTooltip() | translate }}
                </ng-template>
            </div>
        }
    </div>

    @if (isBlockHidden()) {
        <div class="hidden-block">
            {{ hiddenBlockText() | translate }}
        </div>
    } @else {
        <web-default-block-view [entity]="entity()" />
    }

    @if (hideControls) {
        @if (canAddTop() && hoverState()?.topThreshold) {
            <web-add-buttons
                type="top"
                [show]="true"
                [tooltipText]="'control_add_block' | translate"
                (addEvent)="addBlockTop()"
            />
        }
        @if (canAddBottom() && hoverState()?.bottomThreshold) {
            <web-add-buttons
                type="bottom"
                [show]="true"
                [tooltipText]="'control_add_block' | translate"
                (addEvent)="addBlockBottom()"
            />
        }

        <web-shared-block-controls
            class="block-controls"
            [class.row-controls]="itemControls().rowControls"
            [class.basic-controls-position]="itemControls().basicControlsPosition"
            [class.small-top-indent]="itemControls().smallTopIndent"
            [class.small-bottom-indent]="itemControls().smallBottomIndent"
            [class.bottom-inner-controls-position]="itemControls().bottomInnerControlsPosition"
            [class.bottom-outer-controls-position]="itemControls().bottomOuterControlsPosition"
            [selectActionTooltip]="'control_block_settings' | translate"
            [isBlockHidden]="isBlockHidden()"
            [saveBlockToGallery]="!isAdmin"
            (copyEvent)="copyBlock()"
            (deleteEvent)="removeBlock()"
            [disableCopyEvent]="isEcommerceMode"
            [disableDeleteEvent]="isEcommerceMode"
            (selectEvent)="selectBlock()"
            (toggleMoreActionState)="setSettingsMenuOpened($event)"
            (hideBlockEvent)="hideBlock()"
            (showBlockEvent)="showBlock()"
            (saveBlockToGalleryEvent)="saveBlockToGallery()"
        />
    }
</div>
